// Trading UI state (shared, runes). Driven by the server's trade messages; the
// TradeWindow reads `state`, the incoming prompt reads `incoming`, and completion
// surfaces `result` (a summary toast). The server is authoritative, the window only
// proposes offers and reflects the TradeState it sends back.

import type { TradeState } from "@ygoevo/world-protocol";

export const trade = $state({
  /** Pending invite from another player (accept/decline). */
  incoming: null as { fromUserId: string; fromName: string } | null,
  /** Trade window is open. */
  open: false,
  withName: "",
  /** Authoritative both-sides snapshot from the server. */
  state: null as TradeState | null,
  /** Completed-trade summary (cards gained/lost) for the result toast. */
  result: null as { gained: number[]; lost: number[] } | null,
  /** Transient notice (declined / cancelled / ended). */
  notice: null as string | null,
});

export function resetTrade(): void {
  trade.open = false;
  trade.withName = "";
  trade.state = null;
}
